import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f86f44a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view groups" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "groups__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "groups__title" }, "Groups")
], -1))
const _hoisted_3 = { class: "groups__utils" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add group ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "person_add", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "groups__table"
}
const _hoisted_8 = {
  key: 0,
  class: "groups__table-utils"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "file_upload", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Export results")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "groups__table-row" }
const _hoisted_13 = { class: "groups__table-cell table__check" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "groups__table-cell table__group-name" }, "Group name", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "groups__table-cell table__color" }, "Color", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "groups__table-cell table__number-of-users" }, "Number of users", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "groups__table-cell table__actions" }, null, -1))
const _hoisted_18 = { class: "groups__table-body" }
const _hoisted_19 = { class: "groups__table-cell table__check" }
const _hoisted_20 = { class: "groups__table-cell table__group-name" }
const _hoisted_21 = { class: "groups__table-cell table__color" }
const _hoisted_22 = { class: "groups__table-cell table__number-of-users" }
const _hoisted_23 = { class: "groups__table-cell table__actions" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Group details")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "edit", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Delete group")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "delete_outline", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "groups__add button button--blank",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addGroup()))
      }, _hoisted_6)
    ]),
    (_ctx.groups)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["groups__table-head", { 'groups__table-head--dark': _ctx.tableUtilsVisible }])
          }, [
            (_ctx.tableUtilsVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "groups__table-utils-btn button button--blue",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportGroupResults && _ctx.exportGroupResults(...args)), ["prevent"]))
                  }, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.areGroupsSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areGroupsSelected) = $event)),
                  binary: true,
                  onClick: _withModifiers(_ctx.toggleAllGroups, ["prevent"])
                }, null, 8, ["modelValue", "onClick"])
              ]),
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17
            ])
          ], 2),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "groups__table-row",
                key: group?.externalId
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Checkbox, {
                    modelValue: group.selected,
                    "onUpdate:modelValue": ($event: any) => ((group.selected) = $event),
                    binary: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: { name: 'UsersView', params: { group: group.externalId }}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "groups__table-pill pill",
                        style: _normalizeStyle({'background-color': `#${group.color}`})
                      }, _toDisplayString(group.name), 5)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    class: "groups__color-ball",
                    style: _normalizeStyle({'background': `#${group.color}`})
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(group.usersCount), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "groups__table-utils-btn button button--yellow",
                    onClick: _withModifiers(($event: any) => (_ctx.groupDetails(group)), ["prevent"])
                  }, _hoisted_27, 8, _hoisted_24),
                  _createElementVNode("button", {
                    class: "groups__table-utils-btn button button--red",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteGroup(group)), ["prevent"])
                  }, _hoisted_31, 8, _hoisted_28)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}